<script>
import Layout from '../../layouts/auth'

import appConfig from '@/app.config'
import { email, required, minLength, maxLength } from 'vuelidate/lib/validators'
import { LOGIN } from '@/services/api/auth'
import moment from 'moment'
moment.locale('id')
import Swal from 'sweetalert2'
import { MixPanel } from '@/mixin/mixpanel'

/**
 * Login component
 */
export default {
  page: {
    title: 'Login',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      submitted: false,
      authError: null,
      tryingToLogIn: false,

      mode: this.$store.state.config.mode,
      host: window.location.host,

      backgroundLogin: {
        backgroundImage: !this.$store.state.whitelabel.checkDomainShow
          ? `url(${require('@/assets/images/login.png')})`
          : '',
      },
    }
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(50),
    },
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null
    },
  },
  methods: {
    // Try to log the user in with the username
    // and password they provided.
    togglePassword() {
      this.showPassword = !this.showPassword
    },
    tryToLogIn() {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      } else {
        if (process.env.VUE_APP_DEFAULT_AUTH === 'firebase') {
          this.tryingToLogIn = true
          // Reset the authError if it existed.
          this.authError = null
          return (
            this.logIn({
              email: this.email,
              password: this.password,
            })
              // eslint-disable-next-line no-unused-vars
              .then((token) => {
                this.tryingToLogIn = false
                // Redirect to the originally requested page, or to the home page
                this.$router.push(
                  this.$route.query.redirectFrom || {
                    name: 'default',
                  }
                )
              })
              .catch((error) => {
                this.tryingToLogIn = false
                this.authError = error ? error : ''
              })
          )
        } else if (process.env.VUE_APP_DEFAULT_AUTH === 'authapi') {
          const input = {
            email: this.email,
            password: this.password,
            timezoneOffset: new Date().getTimezoneOffset(),
          }
          this.$apollo
            .mutate({
              mutation: LOGIN,
              variables: {
                input: input,
              },
            })
            .then((response) => {
              if (response.data.login.isSuccessful) {
                // First case if domain same as env in case for main domain
                if (response.data.login.data.canLogin) {
                  //  Check if user canLogin meaning has no payment due
                  MixPanel.methods.actionAfterLogin(
                    response.data.login.data.token,
                    this.mode,
                    this.email
                  )
                  if (
                    window.location.host === process.env.VUE_APP_MAIN_DOMAIN &&
                    this.mode == 'production'
                  ) {
                    localStorage.setItem('domainName', `${response.data.login.data.domainName}`)
                    // Set 12 Hours Redirect expired
                    localStorage.setItem(
                      'domainNameExpired',
                      moment(new Date()).add(12, 'hours').valueOf()
                    )
                    localStorage.setItem('payload', response.data.login.data.payload)
                    window.location.href = `${window.location.protocol}//${response.data.login.data.domainName}/authenticate/${response.data.login.data.token}`
                    return
                  } else if (
                    window.location.host === response.data.login.data.domainName ||
                    this.mode != 'production'
                  ) {
                    if (response.data.login.data.canLogin) {
                      //make local Storage
                      localStorage.setItem('token', response.data.login.data.token)

                      localStorage.setItem('domainName', `${response.data.login.data.domainName}`)

                      localStorage.setItem('payload', response.data.login.data.payload)
                      window.location.href = `/?isLoginSuccess=true`
                      return
                    }
                  } else {
                    response.data.login.message = 'email dan password tidak sesuai!'
                    this.$toast.warning(response.data.login.message)
                  }
                } else {
                  // Check if user login in subdomain or in develop env
                  return Swal.fire({
                    title: 'Akun Tidak Bisa Diakses',
                    text: 'Anda belum melakukan pelunasan pembayaran. Silahkan melakukan pembayaran terlebih dahulu.',
                    imageUrl: require(`@/assets/images/alert-report-danger.png`),
                    showCloseButton: true,
                    showConfirmButton: false,
                  })
                }
              } else {
                this.$toast.warning(response.data.login.message)
              }
            })
        }
      }
    },
  },
  mounted() {
    MixPanel.methods.reset()
    MixPanel.methods.unRegister()
  },
}
</script>
<style>
.mc-auth__banner-gray {
  background-color: #aeaeae;
}
</style>
<template>
  <Layout>
    <div class="row">
      <div
        class="col-md-8 col-lg-8 col-xl-9 mc-auth__banner"
        :class="{ 'mc-auth__banner-gray': $store.state.whitelabel.checkDomainShow }"
        :style="backgroundLogin"
      ></div>
      <div class="col-md-4 col-lg-4 col-xl-3 mc-auth__form">
        <div class="mc-auth__logo mt-5">
          <h1>
            <router-link to="/">
              <img src="@/assets/images/main-logo.png" alt />
            </router-link>
          </h1>
        </div>
        <div class="mc-auth__form-wrapper">
          <p class="mc-auth__label">Login to Account</p>

          <b-form class="mc-auth__form-wrapper-deep" @submit.prevent="tryToLogIn">
            <div v-if="notification.message" :class="'alert ' + notification.type">
              {{ notification.message }}
            </div>

            <b-form-group class="mb-3" id="input-group-1" label-for="input-1">
              <b-form-input
                id="input-1"
                v-model="email"
                type="text"
                placeholder="Email"
                :class="{
                  'is-invalid': submitted && $v.email.$error,
                }"
              ></b-form-input>

              <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                <span v-if="!$v.email.required">Email tidak boleh kosong.</span>
                <span v-if="!$v.email.email">Format email tidak sesuai.</span>
              </div>
            </b-form-group>

            <b-form-group class="mb-2 form-password" id="input-group-2" label-for="input-2">
              <b-form-input
                v-if="showPassword"
                id="input-2"
                v-model="password"
                type="text"
                placeholder="Kata Sandi"
                :class="{
                  'is-invalid': submitted && $v.password.$error,
                }"
              ></b-form-input>
              <b-form-input
                v-else
                id="input-2"
                v-model="password"
                type="password"
                placeholder="Kata Sandi"
                :class="{
                  'is-invalid': submitted && $v.password.$error,
                }"
              ></b-form-input>
              <i
                @click="togglePassword"
                class="mc-fa-password"
                :class="{
                  'icon-outline_eye': showPassword,
                  'icon-outline_eye-off-2': !showPassword,
                }"
              ></i>
              <div v-if="submitted && $v.password.$error" class="invalid-feedback">
                <span v-if="!$v.password.required">Kata sandi tidak boleh kosong.</span>
                <span v-if="!$v.password.minLength">Kata sandi minimal 4 karakter.</span>
                <span v-if="!$v.password.maxLength">Kata sandi maksimal 50 karakter.</span>
              </div>
            </b-form-group>

            <b-form-group class="form-check">
              <b-form-checkbox
                id="checkbox-1"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
                v-if="mode == 'development'"
              >
                Ingat Saya
              </b-form-checkbox>
              <span class="mc-auth__flag">
                <img src="@/assets/images/flags/us.jpg" alt v-if="mode == 'development'" />
              </span>
            </b-form-group>

            <div class="mt-5 d-grid">
              <b-button type="submit" variant="primary" class="btn-block">Masuk</b-button>
              <a
                class="text-primary d-block text-center mt-3"
                v-if="!$store.state.whitelabel.checkDomainShow"
                @click="$router.push({ name: 'Forgot Password' })"
                >Lupa Kata Sandi</a
              >
            </div>

            <b-alert show variant="warning" v-if="mode == 'development'" class="mt-3"
              >Development Mode</b-alert
            >
            <b-alert show variant="warning" v-if="mode == 'staging'" class="mt-3"
              >Staging Mode</b-alert
            >
          </b-form>
        </div>
        <div class="mc-auth__copyright" v-if="!$store.state.whitelabel.checkDomainShow">
          <span
            >Dipersembahkan oleh <img src="@/assets/images/copyright-logo.png" alt height="18" class="ms-2"
          /></span>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
